import IArrow from '@imgs/icons/arrow-right.svg';
import styles from './index.less';
import calssnames from 'classnames';
import { Fragment } from 'react';
import classNames from 'classnames';

interface Props {
  breads: {
    text: string;
    onClick?: () => void;
  }[];
  classNames?: string;
  style?: React.CSSProperties;
}

export default function BreadCrumbs(props: Props) {
  const { breads } = props;
  return breads && breads.length ? (
    <ul
      style={props.style}
      className={classNames(styles['bread-crumbs-wrapper'], styles.classNames)}
    >
      {breads.map((breadsItem: any, index: number) => {
        const { text, onClick } = breadsItem;
        const isOnClickFun = typeof onClick === 'function';
        return (
          <Fragment key={text}>
            <li
              className={calssnames(
                styles['bread-crumbs-item'],
                isOnClickFun ? styles['bread-crumbs-link'] : ''
              )}
              onClick={() => {
                if (isOnClickFun) {
                  onClick();
                }
              }}
            >
              {text}
            </li>
            {index === breads.length - 1 ? null : (
              <li className={styles['bread-crumbs-item']}>
                {/* todo: 这里设置 color 无效？ */}
                <IArrow width={14} height={20} />
              </li>
            )}
          </Fragment>
        );
      })}
    </ul>
  ) : null;
}
